import Components from '../../Components';
import { getIsManager } from '../../Core/Utils/userPermissions';

const { containerTypes } = Components.Routes;

const RouteConfig = {
  path: '/home/groupManagement',
  exact: true,
  name: 'navigation.menu.groupmanagement',
  private: true,
  type: containerTypes.PAGE,
  requiresMemberPortalAccess: true,
  isAuthorized: ({ profile }) => {
    return getIsManager(profile);
  },
};

export default RouteConfig;
